import CompanyList from "./components/List"
import CompanyForm from "./components/Form"
import CompanyView from "./components/View"

let module = "companies"

export default [
  { path: "companies", component: CompanyList, meta: { module: module, permissions: ["company-access"] } },
  {
    path: "companies/create",
    component: CompanyForm,
    props: true,
    meta: { module: module, permissions: ["company-create"] }
  },
  {
    path: "companies/edit/:id",
    component: CompanyForm,
    props: true,
    meta: { module: module, permissions: ["company-edit"] }
  }
]
